module.exports = {
      id: "palo-bangla-usage",
      viewBox: "0 0 230 55",
      url: "/" + "sprite-79b777a110ad18271a4fc79289e4208e.svg#palo-bangla",
      toString: function () {
        return this.url;
      }
    }